import { countries } from "../constants/select";
import { useFormatMessage } from "../i18n";

export function useCountriesOptions() {
  const tr = useFormatMessage();

  const countriesOptions = countries.map((country, idx) => (
    <option value={country} key={`${country}-${idx}`}>
      {tr(`country.${country}`)}
    </option>
  ));
  return countriesOptions;
}
